// extracted by mini-css-extract-plugin
module.exports = {"antContent":"InvoiceModal_antContent__cRxlM","closeIcon":"InvoiceModal_closeIcon__0KVk7","modalTitle":"InvoiceModal_modalTitle__BOE14"};